import { ComponentPropsWithoutRef } from 'react';

export default function ArrowsLeftRight(
  props: ComponentPropsWithoutRef<'svg'>,
) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14">
      <g
        stroke="#FFF"
        strokeWidth="1.6"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4.848 8.824L1.2 5.176l3.648-3.648M1.2 5.176h10.272M15.152 5.176L18.8 8.824l-3.648 3.648M18.8 8.824H8.528" />
      </g>
    </svg>
  );
}
